import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask4800To4899Service {

  constructor() { }
}
